export default __webpack_public_path__ + "static/media/menu_ico.2e12c0f7.svg";